import { Pipe, PipeTransform } from "@angular/core";

/**
 *
 * @param bytes
 *
 * @see https://gist.github.com/lanqy/5193417
 */
export function formatBytesToSize(bytes: number, separator = " "): string
{
    /**
     * note: these are technically incorrect abbreviations now, they should be KiB, MiB, GiB, and TiB.
     * @see https://en.wikipedia.org/wiki/Kibibyte
     */
    const sizes = [
        "Bytes", "KB", "MB", "GB", "TB"
    ]; // GB and TB are unrealistic for web-based file uploads....
    if (!bytes) return "n/a";
    const index = Math.min(parseInt(Math.floor(Math.log(bytes) / Math.log(1024))
        .toString(), 10), sizes.length - 1);
    const units = sizes[index];
    const size = index > 0 ? (bytes / Math.pow(1024, index)).toFixed(2) : bytes;
    return `${size}${separator}${units}`;
}

@Pipe({
    name: "fileSize",
    standalone: false
})
export class FileSizePipe implements PipeTransform
{
    transform(bytes: number, separator = " "): string
    {
        return formatBytesToSize(bytes, separator);
    }
}
